import { render, staticRenderFns } from "./delivery-employer.vue?vue&type=template&id=37f98bf4"
import script from "./delivery-employer.vue?vue&type=script&lang=js"
export * from "./delivery-employer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports